import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {getDraftAssistantErrorMessage} from '../../../../../../libs/shared/core/src/helpers/ai/composeHelpers';
import {useLocalize} from '../../../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {Localizer} from '../../../../../../libs/shared/core/src/helpers/internationalization/localizeTypes';
import {AsyncStatusesEnum} from '../../../../../../libs/shared/core/src/helpers/types/asyncStatuses';
import {HttpResponseError} from '../../../../../../libs/shared/core/src/services/http/httpError';
import {AsyncLoader} from '../../../../../../libs/shared/ui/src/components/loaders/asyncLoader';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface DraftAssistantLoaderProps {
  loadingStatus: AsyncStatusesEnum.LOADING | AsyncStatusesEnum.FAILED;
  onRetryClick: () => void;
  loadingMessage: ReactNode;
  error?: HttpResponseError;
}

/*
 * Styles.
 */

const StyledLoaderContainerDiv = styled.div`
  padding: 12px 0px;
`;

const StyledLoaderTextDiv = styled.div`
  font-weight: ${fontWeights.medium};
  ${center()};
  margin-bottom: 12px;
`;

/*
 * Component.
 */

export const DraftAssistantLoader: FC<DraftAssistantLoaderProps> = (props) => {
  const {error, loadingMessage, loadingStatus, onRetryClick} = props;

  const localize = useLocalize();

  return (
    <StyledLoaderContainerDiv>
      {loadingStatus === AsyncStatusesEnum.LOADING && (
        <StyledLoaderTextDiv>{loadingMessage}</StyledLoaderTextDiv>
      )}
      <AsyncLoader
        status={loadingStatus}
        size={VisualSizesEnum.MEDIUM}
        onRetryClick={onRetryClick}
        error={renderErrorMessage(error, localize)}
      />
    </StyledLoaderContainerDiv>
  );
};

function renderErrorMessage(error: HttpResponseError | undefined, localize: Localizer) {
  if (error) {
    return localize(getDraftAssistantErrorMessage(error));
  }

  return null;
}
